import { render } from "./PrintingProfileList.vue?vue&type=template&id=5c50ff3f&scoped=true"
import script from "./PrintingProfileList.vue?vue&type=script&lang=js"
export * from "./PrintingProfileList.vue?vue&type=script&lang=js"

import "./PrintingProfileList.vue?vue&type=style&index=0&id=5c50ff3f&scoped=true&lang=css"

import exportComponent from "/home/yandry/Downloads/s3-integration-app-web-prod(1)/s3-integration-app-web-prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c50ff3f"]])

export default __exports__